export default "__VITE_ASSET__B6y$s7tM__"